'use client';

import { useEffect } from 'react';
import { initGlobalErrorHandler } from '@/lib/monitoring/globalErrorHandler';

export default function GlobalErrorHandlerInit() {
  useEffect(() => {
    initGlobalErrorHandler();
  }, []);

  return null;
}
